import {ChangeDetectionStrategy, Component, computed, effect, Input, input} from '@angular/core';
import {TranslatePipe} from "@ngx-translate/core";
import {NgClass} from "@angular/common";

@Component({
  selector: 'app-cutting-plan',
  standalone: true,
    imports: [
        TranslatePipe
    ],
  templateUrl: './cutting-plan.html',
  styleUrl: './cutting-plan.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,

})
export class CuttingPlan {

    cuttingPlan = input<any>([]); //Lamella and mounting profiles

    groupedCuttingPlan = computed(()=> {
        return Object.values(this.cuttingPlan()?.profiles?.reduce((acc: {[key:string]:any[]}, cur: any)=> {
            const matchKey = JSON.stringify([cur.productCode, cur.color, ...cur.pieces.map((piece: any) => piece.length), cur.leftover ]);
            if(acc?.[matchKey]){
                acc[matchKey].push(cur);
            }else{
                acc[matchKey] = [cur];
            }
            return acc;
        },{})).map((array: any) => ({
           ...array[0],
           count: array.length
        }));
    })

    cuttingPlanFrame = input<any>([]); //Frame profiles
    type  = input<'LAMELLA' | 'MOUNTING_AND_FRAME'>('LAMELLA');


    /**
     * Calculate the width percentage of a piece relative to the profile length.
     *
     * @param length - The length of the piece.
     * @returns The width percentage of the piece.
     */
    countWidth(length: number) {
        const profileLength : number = this.cuttingPlan().profileLength;
        return (length / profileLength) * 100;
    }

    piecesTotalLength(lamellaProfile: any): number {
        return lamellaProfile.pieces.reduce((acc: number, piece: any) => {
            return acc + Number(piece.length);
        }, 0);
    }

    showOverflow(lamellaProfile : any) : boolean {
        return this.piecesTotalLength(lamellaProfile) < this.cuttingPlan().profileLength
    }

}



